class LocalStorageController {

	constructor() {
		this.enabled = false; // process.env.NODE_ENV !== 'development';
	}

	get(key) {
		if (this.enabled) {
			if (localStorage.getItem(key)) {
				return JSON.parse(localStorage.getItem(key));
			}
		}
		return null;
	}

	set(key, val) {
		if (this.enabled) {
			localStorage.setItem(key, JSON.stringify(val));
			return true;
		}
		return null;
	}

	flush() {
		localStorage.clear();
	}

}

export default new LocalStorageController();
